import { Field, FieldProps } from 'formik';
import { ErrorText } from '.';
import TextInput, { BaseProps } from '../base/TextInput';

type Props = BaseProps & {
    name: string;
};

const FormTextInput = ({ name, ...restProps }: Props) => {
    return (
        <Field name={name}>
            {({ field, meta }: FieldProps) => {
                const { touched, error } = meta;
                const hasError = touched && error !== undefined;
                return (
                    <div>
                        <TextInput field={field} hasError={hasError} {...restProps} />
                        <ErrorText>{hasError && error}</ErrorText>
                    </div>
                );
            }}
        </Field>
    );
};

export default FormTextInput;
